export default __webpack_public_path__ + "//i/components/icon/map/hotel//start-new-hotel-search.svg";